import React from "react";
export const KeyValBox = ({
  title,
  id,
  data,
  style,
  valBackground,
  valColor,
  titWidthPerc,
  valWidthPerc,
  minHeight,
  valPostComp,
  valBoxPostComp,
  valInlineStyleOverride,
}) => {
  let titleInlineStyle = {};
  titWidthPerc && (titleInlineStyle.flex = `1 1 ${titWidthPerc}%`);
  let valInlineStyle = {};
  valWidthPerc && (valInlineStyle.flex = `1 1 ${valWidthPerc}%`);
  valBackground && (valInlineStyle.backgroundColor = valBackground);
  valColor && (valInlineStyle.color = valColor);
  minHeight && (valInlineStyle.minHeight = minHeight);
  valInlineStyleOverride && (valInlineStyle = { ...valInlineStyle, ...valInlineStyleOverride });

  return (
    <div className="key-val-box" style={style ? style : {}}>
      <div className="title" style={titleInlineStyle}>
        {title !== "" ? `${title}:` : title}
      </div>
      <div className="value" style={valInlineStyle}>
        {data[id]}
        {valPostComp ? valPostComp : ""}
      </div>
      {titWidthPerc && valWidthPerc && 100 - titWidthPerc - valWidthPerc !== 0 ? (
        <div style={{ flex: `1 1 ${100 - titWidthPerc - valWidthPerc}%` }}>{valBoxPostComp}</div>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/KeyValBox.jsx